import React from 'react';
import HeroSection from '../components/common/HeroSection';
import CareerListings from '../components/careers/CareerListings';
import CareerSection from '../components/careers/CareerSection';

const Career = () => {
  return (
    <div className="career-page">
      <HeroSection 
        title="Career"
        breadcrumb={[{ name: 'Career' }]}
        background="/assets/images/career.jpg"
      />
      <CareerSection />
    </div>
  );
};

export default Career;